import Modal from '@/components/Modal/Modal';
import React, { FC, useMemo } from 'react';
import { TablesSeatsPreview } from '@/services/friends/friendsServicesTypes';
import TableStatus from '@/components/TableStatus/TableStatus';
import Button from '@/components/new-design/Button';
import { replacePathParams } from '@/common/utils/utils';
import ROUTES from '@/routers/Routes';
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';
import useIsMobileView from '@/hooks/useIsMobileView';

interface TableModalCardProps {
  table: TablesSeatsPreview;
}

const TableModalCard: FC<TableModalCardProps> = ({ table }) => {
  const canJoinTable = table && table.table.maxPlayers > table.table.seats.length;
  const onClickJoinTableHandler = () => window.open(replacePathParams(ROUTES.TABLE, { tableId: table.table.id || '' }));
  const isMobileView = useIsMobileView();
  const activePlayerCount = useMemo(
    () => table.table.seats.reduce((acc, seat) => acc + (seat?.active ? 1 : 0), 0),
    [table.table.seats],
  );

  return (
    <div className="rounded-lg bg-[#FFFFFF08] px-6 py-4">
      <div className="flex justify-between gap-3 md:gap-0">
        <TableStatus
          padding={false}
          playerCount={table.table.seats.length}
          activePlayerCount={activePlayerCount}
          maxPlayers={table.table.maxPlayers}
          tableName={table.table.name}
          tableGame={table.table.game}
        />
        <Button disabled={!canJoinTable} className="whitespace-nowrap" onClick={onClickJoinTableHandler}>
          {isMobileView ? 'Join' : 'Join Table'}
        </Button>
      </div>
    </div>
  );
};

interface MultipleTablesModalProps {
  isOpen: boolean;
  isFetching: boolean;
  onClose: () => void;
  tables: TablesSeatsPreview[];
  title: string;
}

const MultipleTablesModal: FC<MultipleTablesModalProps> = ({ isOpen, isFetching, onClose, tables, title }) => {
  return (
    <Modal
      open={isOpen}
      setClose={onClose}
      bodyClassName="overflow-auto scrollbar-track-pn-violet-chark scrollbar-thumb-ph-primary-violet"
      titleComponent={<Modal.Title title={title} onClose={onClose} />}
    >
      <div className="flex flex-col justify-center gap-5">
        {isFetching ? (
          <LoadingSpinner />
        ) : (
          <div className="mb-2 flex flex-col gap-3 md:mb-0">
            {tables && tables.map((table) => <TableModalCard table={table} />)}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default MultipleTablesModal;
